import GenericNavigation from "./GenericNavigation.js";

const CalendarNavigation = ({ liveDates, activeDate, setActiveDate }) => {

  const formatDate = (date) => {
    if (!date) return "Date inconnue";

    const parsedDate = new Date(date);

    if (isNaN(parsedDate)) return "Date invalide";

    return parsedDate.toLocaleDateString("fr-FR", {
      weekday: "long",
      day: "numeric",
      month: "long",
    });
  };

  return (
    <GenericNavigation 
      liveDates={Array.isArray(liveDates) ? liveDates : []}
      activeDate={activeDate || ""}
      setActiveDate={setActiveDate} 
      itemRenderer={formatDate} 
    />
  );
}

export default CalendarNavigation